export class ScreenHelper {

  static getRelationalFontSize(mobileBreakpoint = 1920, baseFontSize = 28) {

    return window.innerWidth <= mobileBreakpoint
      ? baseFontSize * window.innerWidth / mobileBreakpoint
      : baseFontSize
  }

  static getResponsiveLabelSize = () => {
    return Alpine.magicProperties.screen(window).call(this, 'md') ? '16' : '5';
  }

 static getResponsiveLabelSizeForProductPrinter = () => {
    return Alpine.magicProperties.screen(window).call(this, 'md') ? '32' : '8';
  }

}
